
import { Component, Vue } from "vue-property-decorator";
import * as echarts from "echarts";

@Component
export default class MoqupOrganigram extends Vue {

  private option = {
    series: {
      color: ["#ff7f00"],
      type: "sankey",
      layout: "none",
      layoutIterations: 0,
      emphasis: {
        focus: "adjacency",
      },
      orient: "vertical",
      data: [
        { name: "PASS GENERAL" },
        { name: "PASS GENERAL TECHNIQUE" },
        { name: "PASS BATIMENT BASALTE" },
        { name: "PASS BATIMENT BASALTE ETAGE 4" },
        { name: "PASS TECHNIQUE BATIMENT BASALTE" },
        { name: "CLE N° TO4-134" },
      ],
      links: [
        { source: "PASS GENERAL", target: "PASS GENERAL TECHNIQUE", value: 1 },
        { source: "PASS GENERAL", target: "PASS BATIMENT BASALTE", value: 1 },
        {
          source: "PASS BATIMENT BASALTE",
          target: "PASS BATIMENT BASALTE ETAGE 4",
          value: 1,
        },
        {
          source: "PASS BATIMENT BASALTE",
          target: "PASS TECHNIQUE BATIMENT BASALTE",
          value: 1,
        },
        {
          source: "PASS GENERAL TECHNIQUE",
          target: "PASS TECHNIQUE BATIMENT BASALTE",
          value: 1,
        },
        {
          source: "PASS BATIMENT BASALTE ETAGE 4",
          target: "CLE N° TO4-134",
          value: 1,
        },
        {
          source: "PASS TECHNIQUE BATIMENT BASALTE",
          target: "CLE N° TO4-134",
          value: 1,
        },
      ],
    },
  };

  public mounted() {
    const chartDom = document.getElementById("chart-organigram");
    const myChart = echarts.init(chartDom);
    myChart.setOption(this.option);
  }
}
